import { EnvironmentProviders, provideAppInitializer, Provider } from '@angular/core';

import { AnalyticsService } from '../../Domain/Port/analytics.service';
import { InMemoryAnalyticsService } from '../Service/in-memory-analytics.service';
import { setupAnalyticsRouterTracking } from './analytics-router-tracking';

/**
 * Provides the analytics service dependencies required for the development environment.
 *
 * The `provideDevAnalytics` function returns an array of providers that configure
 * the analytics service for use during application development. This includes an
 * in-memory implementation of the analytics service and initializes analytics
 * router tracking.
 *
 * @returns {Array<Provider | EnvironmentProviders>} An array of providers for the development analytics setup.
 */
export const provideDevAnalytics = (): Array<Provider | EnvironmentProviders> => {
    return [
        {
            provide: AnalyticsService,
            useClass: InMemoryAnalyticsService
        },
        provideAppInitializer(setupAnalyticsRouterTracking())
    ];
};
